module.exports = __webpack_public_path__ + "static/media/dental_product_one.1fccb441.png";